import { useMemo } from "react";
import { Option } from "../../components/Select";
import { useCompanyStatusList } from "../useCompanyStatusList";

const toTitle = (s: string) =>
  s ? s.toString().replace(/^\w/, (c: string) => c.toUpperCase()) : "";

export const useCompanyStatusOptions = () => {
  const { data, isLoading, ...rest } = useCompanyStatusList();

  const options: Option[] = useMemo(() => {
    const list = Array.isArray(data) ? data : [];
    return list.map((s: any) => ({
      label: toTitle(s.status ?? ""),
      value: s.id,
      data: s,
    }));
  }, [data]);

  return { options, isLoading, ...rest };
};
